define('app/models/success_guest_register_user',['app/setup'], function(takhfifan) {
  takhfifan.successGuestRegisterUser = Backbone.Model.extend({

    validation: {
      'password': {
        required: true,
        rangeLength: [6,50],
        pattern: /^\S{6,50}$/,
        msg: i18n.t('password_invalid')
      },
      'telephone': function (value, key, fields) {
        var pat = new RegExp(/(09)[123]\d+$/);
          if(!pat.test(value) && value.length != 0) {
            return i18n.t('telephone_invalid')
          }
          else if(value.length > 0 && value.length != 11) {
            return i18n.t('telephone_range')
          }
      }
    },

    register: function() {
      var remove = ['submitUrl', 'need_suburb', 'need_area'];
      var thisData = this.toJSON();

      _.each(remove, function(r) {
        delete thisData[r];
      });

      $.post(this.get('submitUrl'), thisData).done(function(data){
        if (!_.isNull(data.errors) && !_.isEmpty(data.errors)) {
          takhfifan.eventHub.trigger('guestcustomer:registrationError', data.errors);
        }
        else if(data.result) {
          takhfifan.eventHub.trigger('message:show', {
            type: 'success',
            msg: 'ثبت نام با موفقیت انجام شد.'
          });
          window.location.href = "/customer/account/#edit";
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'guestcustomer:registrationError', [i18n.t('connection_error')]
          );
      });
    },

    defaults: {
      accepted_privacy_policy: false
    }
  });
});

